export const RESET_STATE = 'RESET_STATE';

// FETCH_AGREEMENT
export const FETCH_AGREEMENT_PENDING = 'FETCH_AGREEMENT_PENDING';
export const FETCH_AGREEMENT_FULFILLED = 'FETCH_AGREEMENT_FULFILLED';
export const FETCH_AGREEMENT_ERROR = 'FETCH_AGREEMENT_ERROR';
